import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface selectedNetwork {
    selectedNetwork: string,
   
  }

const initialState :selectedNetwork= {
    selectedNetwork: '',
};

export const selectedNetworkSlice = createSlice({
    name: "selectedNetwork",
    initialState,
    reducers: {
        updateNetwork: (state, action: PayloadAction<string>) => {

            state.selectedNetwork = action.payload

        },
    },
});
export const { updateNetwork } = selectedNetworkSlice.actions;

export default selectedNetworkSlice.reducer;
